import { useEffect, useState, createContext } from "react";

import IconButton from "@mui/material/IconButton";
import { Box, Grid, Typography } from "@mui/material";
import { GetComponentTypes } from "../model/ComponentTypes";
import { InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import WidgetButton from "./WidgetButton";

export const WidgetContext = createContext();

const CreateWidgetWithComponent = ({
  title = "Device",
  subtitle = "Device N/A",
  comp = "No Component",
  compData = {}, //possibly use useContext for compdata. compinfo
  // inputHeight = "25vh",
  icon = "",
  xs = "3",
  showTopBox = true,
}) => {
  //Passing Data
  const [compInfo, setCompInfo] = useState(compData);
  useEffect(() => {
    setCompInfo(() => {
      return {
        ...compData,
      };
    });
  }, [JSON.stringify(compData)]); //bad practice

  return (
    <WidgetContext.Provider
      value={{
        compInfo,
        title,
        subtitle,
        comp,
        setCompInfo,
        compData,
        icon,
      }}
    >
      <Box border={"1px solid #A7A7A7"} borderRadius={2} margin={"5px"}>
        <Grid
          item
          xs={4}
          //borderBottom={showTopBox ? "solid silver" : "none"}
          p={1}
          className="font-face-vzb"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {showTopBox ? (
              <Box>
                <Typography
                  sx={{ fontWeight: 700, fontSize: "16px" }}
                  fontWeight="600"
                  paddingLeft={0.8}
                >
                  {title === "Overview" && compData[2]
                    ? compData[2].charAt(0).toUpperCase() + compData[2].slice(1)
                    : title}
                </Typography>
              </Box>
            ) : null}

            {title === "Sensors" ? (
              <WidgetButton icon={<SettingsIcon />} />
            ) : (
              ""
            )}

            {title === "Gateway Health" ? <WidgetButton /> : ""}

            {title === "Gateway Locations" ? (
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  ml: "auto",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search Gateways"
                  inputProps={{
                    "aria-label": "search google maps",
                  }}
                />
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
              </Box>
            ) : (
              ""
            )}
            {title === "Overview" ? (
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  ml: "auto",
                }}
              >
                {/* <DatePicker
                                type="calendar"
                                size="large"
                                surface="light"
                                label="Label"
                                dateFormat="MM/DD/YYYY"
                            />
                            <DatePicker
                                type="calendar"
                                size="large"
                                surface="light"
                                label="Label"
                                dateFormat="MM/DD/YYYY"
                            />
                            <Button
                                size="small"
                                disabled={false}
                                use="primary"
                                onClick={e => alert('Button clicked')}
                                surface="light">
                                Apply
                            </Button> */}
              </Box>
            ) : (
              ""
            )}
            {icon}
          </Box>

          {subtitle && title === "Gateway Locations" ? (
            <Typography
              sx={{ fontWeight: 400, fontSize: "14px" }}
              paddingLeft={1}
            >
              {subtitle}
              {/*Might need to cchange this for 100s of devices */}
            </Typography>
          ) : (
            ""
          )}

          {subtitle && comp === "pieChart" ? (
            <Typography
              sx={{ fontWeight: 400, fontSize: "14px" }}
              paddingLeft={1}
            >
              {subtitle}
            </Typography>
          ) : (
            ""
          )}
        </Grid>

        <Box>{GetComponentTypes(comp, title, compInfo)}</Box>
      </Box>
    </WidgetContext.Provider>
  );
};

export default CreateWidgetWithComponent;
